import { useMediaQuery } from '@material-ui/core';
import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'react-jss';
import FilterSelect from '../../../components/filter-select';
import PeriodSlider from '../../../components/period-slider';
import TerritoriesAutocomplete from '../../../components/territories-autocomplete';
import FiltersContext from '../../../context/filtering';
import useStyles from '../styles';

/**
 * Provides the data and components of the cases filters.
 */
export default function CasesFilters() {
  const theme = useTheme();
  const classes = useStyles({ theme });
  const isBreak = useMediaQuery('(max-width:999px)');
  const { options, values, setters } = useContext(FiltersContext);
  const { t } = useTranslation();

  /**
   * Render the scalesFilter component using memo.
   */
  const scalesFilter = useMemo(
    () => (
      <FilterSelect
        filterName={t('scales_title')}
        options={options.scales}
        value={values.scale}
        setValue={setters.setScale}
        firstColor={theme.colorPrimary}
        secondColor={theme.colorSecondary}
      />
    ),
    [t, options.scales, values.scale]
  );

  /**
   *  Render the dataType filter component using memo.
   */
  const dataTypeFilter = useMemo(
    () => (
      <FilterSelect
        filterName={t('dataType_title')}
        options={options.casesDataTypes}
        value={values.casesDataType}
        setValue={setters.setCasesDataType}
        firstColor={theme.colorPrimary}
        secondColor={theme.colorSecondary}
      />
    ),
    [t, options.casesDataTypes, values.casesDataType]
  );

  return useMemo(
    () => (
      <>
        <div className={classes.filterItem}>
          <TerritoriesAutocomplete
            filterName="Território"
            firstColor={theme.colorPrimary}
            secondColor={theme.colorSecondary}
          />
        </div>
        <div className={classes.filterItem}>{scalesFilter}</div>
        <div className={classes.filterItem}>{dataTypeFilter}</div>

        {options.dates && (
          <div
            style={isBreak ? { minWidth: 'none' } : { minWidth: '120px' }}
            className={classes.filterItem}
          >
            <PeriodSlider
              datesOptions={options.dates}
              setDate={setters.setDate}
              firstColor={theme.colorPrimary}
              secondColor={theme.colorSecondary}
            />
          </div>
        )}
      </>
    ),
    [classes, scalesFilter, dataTypeFilter, isBreak]
  );
}
